import { render, staticRenderFns } from "./SpecialView.vue?vue&type=template&id=a54a430c&scoped=true"
import script from "./SpecialView.vue?vue&type=script&lang=js"
export * from "./SpecialView.vue?vue&type=script&lang=js"
import style0 from "./SpecialView.vue?vue&type=style&index=0&id=a54a430c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54a430c",
  null
  
)

export default component.exports